import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Box, BoxProps } from '@mui/material';

type ThumbnailProps = BoxProps & {
  src: string | null;
  type?: string; // ts - replace with list of entity types
  height?: number;
};

const Thumbnail = ({ src, type, height = 50, ...props }: ThumbnailProps) => {
  return (
    <ThumbnailBox draggable="false" style={{ height, width: height, minWidth: height }} {...props}>
      {src ? <img src={src} /> : type === 'feature' ? <PolarisIcon icon="movie_roll" height={30} /> : <PolarisIcon icon="tv" height={30} />}
    </ThumbnailBox>
  );
};

export default Thumbnail;

const ThumbnailBox = styled(Box)`
  border-radius: ${({ theme }) => theme.shape.borderRadius};
  background: ${({ theme }) => theme.palette.background.default};
  display: flex;
  align-items: center;
  justify-content: center;
  user-drag: none;
  overflow: hidden;

  img {
    width: 102%;
    height: 102%;
    object-fit: cover;
    margin-left: -1%;
    user-drag: none;
    margin-top: -1%;
  }

  svg {
    opacity: 0.2;
  }
`;
